import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { getAuthToken } from "../../lib/api/tokenStore";
import TabStrip from "../detail/components/TabStrip";
import useTransactions from "./useTransactions";
import FinanceShell from "./components/FinanceShell";
import TransactionList from "./components/TransactionList";
import TransactionDetailDialog from "./components/TransactionDetailDialog";
import FinanceEmptyState from "./components/FinanceEmptyState";
import { TransactionRowsSkeleton } from "./components/FinanceSkeletons";
import { FINANCE_EMPTY_STATES } from "./financeCopy";
import { TRANSACTION_PURPOSES } from "./financeMappers";
import { FINANCE_PATH, orderDetailPath } from "./financeRoutes";

import "../checkout/styles.css";
import "./styles.css";

const TABS = [
  { id: "all", label: "All", purpose: undefined, empty: FINANCE_EMPTY_STATES.noTransactions },
  {
    id: "top-ups",
    label: "Top-ups",
    purpose: TRANSACTION_PURPOSES.TOP_UP,
    empty: FINANCE_EMPTY_STATES.noTopUps,
  },
  {
    id: "payments",
    label: "Payments",
    purpose: TRANSACTION_PURPOSES.PURCHASE,
    empty: FINANCE_EMPTY_STATES.noPayments,
  },
];

const TransactionsRoute = () => {
  const navigate = useNavigate();
  const enabled = Boolean(getAuthToken());

  const [tabId, setTabId] = useState("all");
  const [selected, setSelected] = useState(null);

  const tab = TABS.find((row) => row.id === tabId) || TABS[0];
  const transactions = useTransactions({ purpose: tab.purpose, enabled });

  return (
    <FinanceShell
      title="Transactions"
      backTo={FINANCE_PATH}
      showBack={false}
    >
      {(transactions.isLoading ||
        transactions.isError ||
        transactions.items.length > 0 ||
        tabId !== "all") && (
        <TabStrip
          tabs={TABS.map(({ id, label }) => ({ id, label }))}
          activeId={tabId}
          label="Transaction type"
          onSelect={setTabId}
        />
      )}

      {transactions.isLoading ? (
        <section className="sy-flow-card">
          <div className="sy-flow-card-body">
            <TransactionRowsSkeleton rows={6} />
          </div>
        </section>
      ) : transactions.isError ? (
        <FinanceEmptyState
          state={FINANCE_EMPTY_STATES.transactionsError}
          onRetry={transactions.refetch}
        />
      ) : transactions.items.length ? (
        <section className="sy-flow-card">
          <div className="sy-flow-card-body">
            <TransactionList items={transactions.items} onSelect={setSelected} />

            {transactions.isPaging && <TransactionRowsSkeleton rows={3} />}

            {transactions.canLoadMore && (
              <button
                type="button"
                className="sy-flow-btn sy-flow-btn-ghost fin-load-more"
                onClick={transactions.loadMore}
              >
                Load More
              </button>
            )}
          </div>
        </section>
      ) : (
        <FinanceEmptyState state={tab.empty} />
      )}

      {selected && (
        <TransactionDetailDialog
          transaction={selected}
          onClose={() => setSelected(null)}
          onViewOrder={(orderId) => navigate(orderDetailPath(orderId))}
        />
      )}
    </FinanceShell>
  );
};

export default TransactionsRoute;
